@use '../vars.scss' as vars;

.flexpay-logo {
  margin: 0 0 0 5px;
  width: 132px;

  @media screen and (max-width: vars.$mobile) {
    width: 100px;
  }
}
